import { VBtn } from 'vuetify/lib/components/VBtn';
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("title",function(){return [_c('vAlertHeader',{attrs:{"title":"Enter Coupon Code","color":_vm.getThemeColor}})]}),_c(VOtpInput,{attrs:{"disabled":_vm.loading,"length":7},model:{value:(_vm.coupon),callback:function ($$v) {_vm.coupon=$$v},expression:"coupon"}}),_c(VBtn,{staticClass:"mt-3",attrs:{"x-large":"","color":"#2E7D32","dark":""},on:{"click":function($event){return _vm.submitCoupon()}}},[_vm._v("Submit")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }